export default "/images/web-button-store-cropped.png?0146cb376a2bea3619680e6ad4586058";